// extracted by mini-css-extract-plugin
module.exports = {"container":"SubHeader_container__3PpwS","green":"SubHeader_green__2H5SS","red":"SubHeader_red__1kagf"};